import { useQuery } from "@tanstack/react-query";
import { get } from "lib/http";

export const useCouponAmount = (customer_file_id: number) => {
  const fetchCouponAmount = async (customer_file_id: number): Promise<number> => {
    return await get("/payment/coupon-amount/", {
      customer_file_id: customer_file_id,
    });
  };
  const { data, isLoading } = useQuery<number>(["coupon-amount", customer_file_id], async () =>
    fetchCouponAmount(customer_file_id)
  );
  return { amount: data, isLoading };
};
